
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ButtonModule } from 'primeng/button';
import { SafeResourceUrl } from '@angular/platform-browser';
import { GlobalWorkerOptions } from 'pdfjs-dist';

@Component({
  selector: 'app-pdf-preview',
  template: `
    <!-- <div class="d-flex justify-end mb-3 w-full">
      <button
        pButton
        type="button"
        icon="pi pi-times"
        (click)="fechar()"
      ></button>
    </div> -->
    <pdf-viewer
      [src]="pdfSrc"
      [render-text]="true"
      style="display: block; width: 100%; height: 100vh; padding: .5rem; margin: 0; border:1.5px solid #ccc; overflow: hidden;"
    ></pdf-viewer>
  `,
  imports: [PdfViewerModule, ButtonModule],
  standalone: true,
  styles: [],
})
export class PdfPreviewComponent {
  @Input() pdfSrc: string | SafeResourceUrl | undefined;
  @Output() fecharPreview = new EventEmitter<void>();


  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    GlobalWorkerOptions.workerSrc = 'assets/pdf-worker/pdf.worker.min.mjs';
    const blob = config.data?.blob;
    if (blob) {
      this.pdfSrc = URL.createObjectURL(blob);
    }
  }
  fechar() {
    this.fecharPreview.emit();
  }
}

// import { Component, OnInit } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
// import { PdfViewerModule } from 'ng2-pdf-viewer';
// import { ButtonModule } from 'primeng/button';
// import { GlobalWorkerOptions } from 'pdfjs-dist';

// @Component({
//   selector: 'app-pdf-preview',
//   template: `
//     <div *ngIf="loading" class="pdf-loading">
//       <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
//       <p>A carregar documento...</p>
//     </div>

//     <pdf-viewer
//       *ngIf="!loading && pdfSrc"
//       [src]="pdfSrc"
//       [render-text]="true"
//       [original-size]="false"
//       style="display: block; width: 100%; height: 80vh;"
//     ></pdf-viewer>

//     <div *ngIf="!loading && !pdfSrc" class="pdf-error">
//       <i class="pi pi-times-circle" style="font-size: 2rem; color: red"></i>
//       <p>Erro ao carregar o documento.</p>
//     </div>
//   `,
//   styles: [`
//     .pdf-loading, .pdf-error {
//       display: flex; flex-direction: column;
//       align-items: center; justify-content: center;
//       height: 80vh; gap: 1rem; color: #666;
//     }
//   `],
//   standalone: true,
//   imports: [PdfViewerModule, ButtonModule, CommonModule],
// })
// export class PdfPreviewComponent implements OnInit {
//   pdfSrc: Uint8Array | undefined;
//   loading = true;

//   constructor(
//     private ref: DynamicDialogRef,
//     private config: DynamicDialogConfig
//   ) {
//     GlobalWorkerOptions.workerSrc = 'assets/pdf-worker/pdf.worker.min.mjs';
//   }

//   ngOnInit(): void {
//     const blob: Blob = this.config.data?.blob;

//     if (blob) {
//       blob.arrayBuffer()
//         .then((buffer) => {
//           this.pdfSrc = new Uint8Array(buffer);
//           this.loading = false;
//         })
//         .catch(() => {
//           this.loading = false;
//         });
//     } else {
//       this.loading = false;
//     }
//   }

//   fechar() {
//     this.ref.close();
//   }
// }